export default "__VITE_ASSET__85361545__"